/**
 * Store 模块统一导出
 * 提供所有store模块的便捷访问
 */

// 导入各store模块
import { useAuthStore } from './auth'
import { useAppStore } from './app'
import { useSettingsStore } from './settings'
import { useUserPreferencesStore } from './userPreferences'
import { useDictStore } from './dict'

// 统一导出所有store hook
export {
  useAuthStore,
  useAppStore,
  useSettingsStore,
  useUserPreferencesStore,
  useDictStore
}

// 导出store类型定义
export type AuthStore = ReturnType<typeof useAuthStore>
export type AppStore = ReturnType<typeof useAppStore>
export type SettingsStore = ReturnType<typeof useSettingsStore>
export type UserPreferencesStore = ReturnType<typeof useUserPreferencesStore>

/**
 * 批量初始化所有store
 * 在应用启动时调用，进行必要的初始化操作
 */
export const initializeStores = async (): Promise<void> => {
  try {
    // 初始化app store
    const appStore = useAppStore()
    await appStore.initialize()
    
    // 初始化settings store
    const settingsStore = useSettingsStore()
    await settingsStore.initialize()
    
    // 记录应用启动
    const userPrefsStore = useUserPreferencesStore()
    userPrefsStore.recordAppLaunch()
    
    console.log('All stores initialized successfully')
  } catch (error) {
    console.error('Failed to initialize stores:', error)
    // 初始化失败不影响应用运行，只记录错误
  }
}